// extracted by mini-css-extract-plugin
export default {"BackBtn":"BackButton_BackBtn__Lic3C"};